import { CustomColors } from '@space-core/styles'
import type { ThemeMode } from '@space-core/styles/themes/enum'
import { ColorsTypes } from '@space-core/styles/themes/enum'
import { SessionMode } from '@space-shell/common/components/baseStructure/enum'

const useCustomColors = () => {
  const customColors = (color: string, theme: ThemeMode, session: SessionMode) => {
    if (session === SessionMode.DEFAULT) {
      document.documentElement.style.setProperty(
        '--structure-menu-item-bg',
        `${CustomColors.switchColors(color, ColorsTypes.LIGHTEST, theme)}`
      )
    }

    document.documentElement.style.setProperty(
      '--custom-color-lightest',
      `${CustomColors.switchColors(color, ColorsTypes.LIGHTEST, theme)}`
    )

    document.documentElement.style.setProperty(
      '--custom-color-lighter',
      `${CustomColors.switchColors(color, ColorsTypes.LIGHTER, theme)}`
    )

    document.documentElement.style.setProperty(
      '--custom-color-light',
      `${CustomColors.switchColors(color, ColorsTypes.LIGHT, theme)}`
    )

    document.documentElement.style.setProperty(
      '--custom-color-normal',
      `${CustomColors.switchColors(color, ColorsTypes.NORMAL, theme)}`
    )

    document.documentElement.style.setProperty(
      '--custom-color-dark',
      `${CustomColors.switchColors(color, ColorsTypes.DARK, theme)}`
    )

    document.documentElement.style.setProperty(
      '--custom-color-darker',
      `${CustomColors.switchColors(color, ColorsTypes.DARKER, theme)}`
    )

    document.documentElement.style.setProperty(
      '--custom-color-darkest',
      `${CustomColors.switchColors(color, ColorsTypes.DARKEST, theme)}`
    )
  }

  return { customColors }
}

export default useCustomColors
